import React from 'react'

const SingleHotel = () => {
  return (
    <div>SingleHotel</div>
  )
}

export default SingleHotel